import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { fieldsReducer } from '../features/fields';

export const store = configureStore({
  reducer: {
    fields: fieldsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
